import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'urldecode',
  standalone: true,
})
export class UrlDecodePipe implements PipeTransform {
  transform(html: string): string {
    if (html == null) {
      return '';
    }
    const e = document.createElement('textarea');
    e.innerHTML = html;
    // handle case of empty input
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  }
}
